import api from "core/api";
import asyncThunk from "core/decorators/toolkit";

export const ListProject = asyncThunk("panel/beta/listProjects", api.project.switchProjects, {});
